<template>
  <div>
    <!-- Menu burger pour mobile -->
    <!--<div class="lg:hidden fixed top-4 left-4 z-50">
      <button @click="toggle" class="burger-button" :class="{ 'open': open }">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div> -->

    <!-- Menu mobile -->
  <!-- <nav v-if="open" class="lg:hidden fixed top-0 left-0 w-full h-full bg-[#00071a]/95 z-40 flex flex-col justify-center items-center gap-8 text-white font-bold text-[5vw]">
      <span @click="toggle"><router-link to="/" @click="toggle">ACCUEIL</router-link></span>
      <span @click="toggle"><a href="https://www.vodka-poliakov.com/mypoliakov-cgv/" target="_blank" @click="toggle">POLITIQUE DE CONFIDENTIALITÉ</a></span>
      <span @click="toggle"><a href="https://oxoformdocs.fra1.digitaloceanspaces.com/68dfa4e4243c47eb8c104be4/reglement.pdf" target="_blank" @click="toggle">RÉGLEMENT</a></span>
      <span @click="toggle"><a href="https://www.vodka-poliakov.com/mentions-legales/" target="_blank" @click="toggle">MENTIONS LÉGALES</a></span>
    </nav> -->

    <!-- Header desktop -->
    <header class=" pt-[1%] lg:block hidden max-w-[1920px] mx-auto">
   <!--   <router-link to="/"><img src="@/assets/logo-min.png" alt="home" class="mx-auto w-[12.9%]" /></router-link>
      <div class="absolute w-full flex justify-betwwen  items-center top-[8%] text-white font-bold" >
        <div class="w-[50%] text-center flex justify-center gap-[2vw] pl-[0%]"><router-link to="/">ACCUEIL</router-link> <a href="https://www.vodka-poliakov.com/mypoliakov-cgv/"  target="_blank">POLITIQUE DE CONFIDENTIALITÉ</a></div>
        <div class="w-[50%] text-center flex justify-center gap-[2vw] pr-[5%]"><a href="https://oxoformdocs.fra1.digitaloceanspaces.com/68dfa4e4243c47eb8c104be4/reglement.pdf" target="_blank">RÉGLEMENT</a> <a href="https://www.vodka-poliakov.com/mentions-legales/" target="_blank">MENTIONS LÉGALES</a></div>
      </div> -->
    </header> 

    <!-- Popup de majorité - visible sur tous les écrans -->
    <div v-if="showPopup" class="w-full h-full bg-[#00071a]/90 fixed top-0 left-0 z-50 flex justify-center items-center lg:p-4 p-6">
      <div class="w-full max-w-[900px] border-[6px] lg:border-[10px] border-white text-white text-center lg:pt-[5%] pt-[8%]">
        <h1 class="text-[7vw] lg:text-[3vw] font-bold leading-[8.5vw] lg:leading-[3.5vw] px-6 lg:px-4">
          ÊTES-VOUS MAJEUR<br>
          DANS VOTRE PAYS DE<br>
          RÉSIDENCE ?
        </h1>

        <p class="btns">
          <button @click="handleYes" class="bg-white !text-red-500">OUI</button>
          <button @click="handleNo" class="bg-transparent !text-white">NON</button>
        </p>

        <div class="border-t-[6px] lg:border-t-[10px] border-white mt-[5%] lg:mt-[5%] flex justify-center items-center py-[5%] lg:py-[3%] text-[3.2vw] lg:text-[1vw] px-6 lg:px-4 leading-tight">
          <p>En entrant sur ce site, vous acceptez les <span class="underline">Conditions d'utilisation</span><br class="lg:hidden"> et la <span class="underline">politique de confidentialité</span>.<br>
            L'ABUS D'ALCOOL EST DANGEREUX POUR LA SANTÉ,<br class="lg:hidden"> À CONSOMMER AVEC MODÉRATION.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: "header-view",
  components: {

  },
  data() {
    return {
      open: false,
      showPopup: false,
    };
  },
  mounted() {
    // Vérifier si l'utilisateur a déjà confirmé sa majorité
    const isAdult = sessionStorage.getItem('isAdult');
    if (isAdult === 'true') {
      this.showPopup = false;
    }
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    handleYes() {
      // Fermer le popup et stocker l'information dans sessionStorage
      sessionStorage.setItem('isAdult', 'true');
      this.showPopup = false;
    },
    handleNo() {
      // Ne rien faire quand on clique sur NON
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>

<style scoped>
.btns {
  @apply flex flex-col lg:flex-row justify-center gap-[3vw] lg:gap-[2vw] mt-[8%] lg:mt-[5%] px-6 lg:px-4;
}

.btns button {
  @apply text-[5vw] lg:text-[1.2vw] px-[2vw] py-[4vw] lg:py-[1vw] w-full lg:w-[35%] font-bold border-2 border-white;
}

/* Menu burger */
.burger-button {
  width: 30px;
  height: 25px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.burger-button span {
  display: block;
  width: 100%;
  height: 3px;
  background-color: white;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.burger-button.open span:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.burger-button.open span:nth-child(2) {
  opacity: 0;
}

.burger-button.open span:nth-child(3) {
  transform: rotate(-45deg) translate(8px, -8px);
}

/* Menu mobile */
nav a {
  transition: opacity 0.3s ease;
}

nav a:hover {
  opacity: 0.7;
}
</style>
